import type { RouteRecordRaw } from 'vue-router';

// Cloud settings — one page per provider, three tabs behind `?tab=`. The
// sidebar only offers the providers the account actually has regions for
// (Sidebar.vue's cloudChildren), but a hand-typed /cloud/<other> still resolves
// here and falls back to AWS rather than 404ing, as legacy did.
const cloudRoutes: RouteRecordRaw[] = [
  {
    // Bare /cloud is the sidebar group header's target.
    path: '/cloud',
    redirect: '/cloud/aws',
  },
  {
    path: '/cloud/:csp',
    name: 'cloud-settings',
    component: () => import('@/domains/cloud/views/CloudSettingsView.vue'),
    meta: { renderer: 'native', perms: ['cloudSettings@all'] },
  },
];

export default cloudRoutes;
